import React from 'react';
import { Modal } from 'antd';
import AlumlyButton from './AlumlyButton';

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  subTitle?: string;
  handleClose: () => void;
  handleSubmit: () => void;
  imageUrl?: string;
}

// Confirm/delete dialog, now backed by Ant Design's Modal (kept the same prop
// API so all callers keep working).
const ConfirmModal: React.FC<ConfirmModalProps> = (props) => {
  const {
    isOpen, handleClose, subTitle, handleSubmit, imageUrl,
  } = props;

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      centered
      width={460}
    >
      <div style={{ textAlign: 'center', padding: '12px 8px 4px' }}>
        {imageUrl ? (
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
            <img src={imageUrl} alt="" style={{ width: 70, height: 70 }} />
          </div>
        ) : null}
        <div style={{ fontSize: 18, fontWeight: 700, color: '#0D1E6A' }}>{subTitle}</div>
      </div>
      <div style={{
        display: 'flex', justifyContent: 'center', gap: 16, marginTop: 24,
      }}
      >
        <AlumlyButton label="rxvWhite" width={150} onClick={handleClose}>Cancel</AlumlyButton>
        <AlumlyButton label="rxv" width={150} onClick={handleSubmit}>Delete</AlumlyButton>
      </div>
    </Modal>
  );
};

ConfirmModal.defaultProps = {
  imageUrl: '',
  subTitle: '',
  title: '',
};

export default ConfirmModal;
